import { render } from "./doctorprofile-settings1.vue?vue&type=template&id=a6e7e9a4"
import script from "./doctorprofile-settings1.vue?vue&type=script&lang=js"
export * from "./doctorprofile-settings1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__